var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTerminalDeviceBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-device"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device",
    clipPath: "url(#clip-device)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2685",
    "data-name": "Rectangle 2685",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    transform: "translate(5.03 3.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6212",
    "data-name": "Group 6212",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11186",
    "data-name": "\\u30D1\\u30B9 11186",
    d: "M8.476,17.073H2.345A1.1,1.1,0,0,1,1.25,15.978V2.345A1.1,1.1,0,0,1,2.345,1.25H12.905A1.1,1.1,0,0,1,14,2.345V10.08a.5.5,0,1,1-1,0V2.345a.1.1,0,0,0-.1-.1H2.345a.1.1,0,0,0-.1.1V15.978a.1.1,0,0,0,.1.1H8.476a.5.5,0,1,1,0,1Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_315",
    "data-name": "\\u7DDA 315",
    d: "M3.488,0H-.5A.5.5,0,0,1-1-.5.5.5,0,0,1-.5-1H3.488a.5.5,0,0,1,.5.5A.5.5,0,0,1,3.488,0Z",
    transform: "translate(1.945 13.461)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_316",
    "data-name": "\\u7DDA 316",
    d: "M9.36,0H-.5A.5.5,0,0,1-1-.5.5.5,0,0,1-.5-1H9.36a.5.5,0,0,1,.5.5A.5.5,0,0,1,9.36,0Z",
    transform: "translate(1.945 3.126)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_317",
    "data-name": "\\u7DDA 317",
    d: "M.931,0H-.5A.5.5,0,0,1-1-.5.5.5,0,0,1-.5-1H.931a.5.5,0,0,1,.5.5A.5.5,0,0,1,.931,0Z",
    transform: "translate(6.418 2.058)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6211",
    "data-name": "Group 6211",
    transform: "translate(4.933 6.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_318",
    "data-name": "\\u7DDA 318",
    d: "M-.5,1.605a.5.5,0,0,1-.5-.5V-.5A.5.5,0,0,1-.5-1,.5.5,0,0,1,0-.5V1.106A.5.5,0,0,1-.5,1.605Z",
    transform: "translate(5.074 3.837)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_319",
    "data-name": "\\u7DDA 319",
    d: "M-.5.712a.5.5,0,0,1-.5-.5V-.5A.5.5,0,0,1-.5-1,.5.5,0,0,1,0-.5V.213A.5.5,0,0,1-.5.712Z",
    transform: "translate(6.504 4.73)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_320",
    "data-name": "\\u7DDA 320",
    d: "M-.5.65A.5.5,0,0,1-1,.15V-.5A.5.5,0,0,1-.5-1,.5.5,0,0,1,0-.5V.15A.5.5,0,0,1-.5.65Z",
    transform: "translate(7.933 5.051)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11187",
    "data-name": "\\u30D1\\u30B9 11187",
    d: "M45.665,59.374a.5.5,0,0,1-.5-.5,2.272,2.272,0,0,1,.478-1.366,1.932,1.932,0,0,0,.411-1.237v-3.33a.27.27,0,0,0-.2-.255.215.215,0,0,0-.228.215.5.5,0,1,1-1,0v-.259a.27.27,0,0,0-.2-.255.215.215,0,0,0-.228.215v.041a.5.5,0,1,1-1,0,.27.27,0,0,0-.2-.255.215.215,0,0,0-.228.215.5.5,0,1,1-1,0V49.566a.215.215,0,0,0-.227-.215.27.27,0,0,0-.2.255v5.93a.5.5,0,0,1-.865.34l-1.3-1.4a.279.279,0,0,0-.427.358l2.561,3.383a1.423,1.423,0,0,1,.263.568.5.5,0,0,1-.984.171.6.6,0,0,0-.074-.135l-2.562-3.384A1.278,1.278,0,0,1,39.908,53.8l.43.463V49.607a1.265,1.265,0,0,1,1.151-1.253,1.2,1.2,0,0,1,.9.331,1.219,1.219,0,0,1,.378.881v1.841a1.231,1.231,0,0,1,.28-.017,1.154,1.154,0,0,1,.638.24,1.181,1.181,0,0,1,1.622.181,1.207,1.207,0,0,1,.6-.121,1.265,1.265,0,0,1,1.15,1.252v3.33a2.892,2.892,0,0,1-.576,1.788,1.331,1.331,0,0,0-.313.815A.5.5,0,0,1,45.665,59.374Z",
    transform: "translate(-37.693 -48.352)",
    fill: "#377ef3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTerminalDeviceBlue);
export default __webpack_public_path__ + "static/media/icon_terminal_device_blue.853eb4228bf8f0310ea2c530dab798db.svg";
export { ForwardRef as ReactComponent };